type Theme = "light" | "dark"

let shellListeners: AbortController | null = null
const FULL_NAVIGATION_PREFIXES = ["/dev/mail", "/admin/jobs", "/admin/resources"]
const THEME_STORAGE_KEY = "app-theme"

function currentTheme(): Theme {
  return document.documentElement.dataset.theme === "dark" ? "dark" : "light"
}

function applyTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme
  localStorage.setItem(THEME_STORAGE_KEY, theme)
}

function updateThemeControls() {
  const theme = currentTheme()
  const nextTheme = theme === "dark" ? "light" : "dark"
  const label = nextTheme === "dark" ? "Dark mode" : "Light mode"
  const action = `Switch to ${nextTheme} theme`

  document.querySelectorAll<HTMLButtonElement>("[data-theme-toggle]").forEach((button) => {
    button.setAttribute("aria-label", action)
    button.setAttribute("title", action)
    const text = button.querySelector<HTMLElement>("[data-theme-label]")
    if (text) text.textContent = label
  })
}

function isolateMountedEngines() {
  document.querySelectorAll<HTMLAnchorElement>("a[href]").forEach((link) => {
    let pathname: string
    try {
      pathname = new URL(link.href, window.location.href).pathname
    } catch {
      return
    }

    if (FULL_NAVIGATION_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
      link.dataset.turbo = "false"
    }
  })
}

function closeAccountMenus(except?: HTMLDetailsElement) {
  document.querySelectorAll<HTMLDetailsElement>("details.account-menu[open]").forEach((menu) => {
    if (menu !== except) menu.open = false
  })
}

export function mountShellUi() {
  shellListeners?.abort()
  shellListeners = new AbortController()
  const { signal } = shellListeners

  const header = document.querySelector<HTMLElement>(".topbar")
  const mobileToggle = document.querySelector<HTMLButtonElement>("#mobile-nav-toggle")
  const themeToggles = document.querySelectorAll<HTMLButtonElement>("[data-theme-toggle]")

  isolateMountedEngines()

  if (mobileToggle && header) {
    mobileToggle.onclick = () => {
      const open = header.dataset.navOpen !== "true"
      header.dataset.navOpen = String(open)
      mobileToggle.setAttribute("aria-expanded", String(open))
      if (!open) closeAccountMenus()
    }
  }

  updateThemeControls()
  themeToggles.forEach((themeToggle) => {
    themeToggle.onclick = () => {
      applyTheme(currentTheme() === "dark" ? "light" : "dark")
      updateThemeControls()
    }
  })

  document.querySelectorAll<HTMLDetailsElement>("details.account-menu").forEach((menu) => {
    menu.addEventListener("toggle", () => {
      if (menu.open) closeAccountMenus(menu)
    }, { signal })
  })

  document.addEventListener("pointerdown", (event) => {
    const target = event.target
    if (!(target instanceof Node)) return
    const insideMenu = target.parentElement?.closest("details.account-menu")
    if (!insideMenu) closeAccountMenus()
  }, { signal })

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAccountMenus()
  }, { signal })
}
